import ApiService from '@/services/api.service'
import type { LeadStatus } from '@/types/leads'

interface LeadIndexParams {
  page?: number;
  per_page?: number;
  filter?: {
    search?: string;
    status?: string;
  };
  [key: string]: any;
}

export default {
  index: (params: LeadIndexParams) => 
    ApiService().get(`/user/leads`, { params }),

  show: (id: number | string) => 
    ApiService().get(`/user/leads/${id}`),

  store: (data: Record<string, any>) => 
    ApiService().post(`/user/leads`, data),

  update: (id: number | string, data: Record<string, any>) => 
    ApiService().put(`/user/leads/${id}`, data),

  updateStatus: (id: number | string, status: LeadStatus | string) => 
    ApiService().patch(`/user/leads/${id}/status`, { status }),

  storeFromContact: (data: Record<string, any>) => 
    ApiService().post(`/user/leads/from-contact`, data),

  destroy: (id: number | string) => 
    ApiService().delete(`/user/leads/${id}`),
}